import { Injectable } from '@angular/core';
import { FdtScriptImporterService } from './fdt-script-importer.service';
import { RpcClientService } from './rpc-client.service';
import * as $ from 'jquery';
declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class FdrsClientService {

  fdrsConnected = false;
  // fdt = new FDTUtil(),
  // commander = new FdrsCommander(fdt);

  constructor(private rpcClientService: RpcClientService,
    private fdtScriptImporterService: FdtScriptImporterService) { }

  /**
 * Utility class for handling connections to FDRS
 *
 */


  initFdrsClient(params: any) {
    var connPromise = $.Deferred();

    if (this.fdrsConnected === false) {
      //var scriptLoader = new scriptLoaderObj(fdt, params);
      this.fdtScriptImporterService.scriptLoader(params);

      this.fdtScriptImporterService.bootsTrapFDTDef.then(() => {
        console.log("FDT is up and running ----------- client");
       // this.fdrsConnected = true;
        connPromise.resolve(this.rpcClientService);
      }, function () {
        connPromise.reject();
      });
    }

    var promises = {
      connPromise: connPromise,
      loadPromise: this.fdtScriptImporterService ? this.fdtScriptImporterService.bootsTrapLoadingDef : connPromise
    };

    window.fdrsPromises = promises;
    window.fdrsClient = this;

    //return promises;
  }

  getFdtUtil() {
    return this.rpcClientService;
  }

  isFdrsConnected() {
    return this.rpcClientService.getConnectionStatus() === this.rpcClientService.connectionStatus.CONNECTED;
  }

  // getFdrsCommander()
  // {
  //     return commander;
  // }

  // return {
  //     initFdrsClient: initFdrsClient,
  //     getFdtUtil: getFdtUtil,
  //     getFdrsCommander: getFdrsCommander,
  //     isFdrsConnected: isFdrsConnected
  // };


}
